/* eslint-disable */
import Vue from 'vue'
import store from '@/store/index'
import MediaDevices from './MediaDevices'

class StreamHealth {
  STREAM_HEALTH_STORAGE_NAME:string = 'ocular_latency_session'
  MAX_TIME:any = 60
  TIME_PING:any = 1000

  timeLimite:any = 0
  startTime:any = null
  intervalClear:any = null
  session:any = null
  userConfigs:any = null

  defaultData = {
	  "cammer_app_generate_data": false,
	  "widget_app_generate_data": false,
	  "show_icons": {
		  "widget": false,
		  "cammer": false
	  },
    "show_charts": {
    	"widget": false,
		  "cammer": false
    }
  }

  checkUserStreamHealth (user:any) {
    this.session = store.state.storage
    const checkCammerStreamHealth = user.user_configs.find((item:any) => item.type == 22 && item.value === 'true')
    this.userConfigs = (checkCammerStreamHealth && checkCammerStreamHealth.data) ? checkCammerStreamHealth.data : this.defaultData

    if (checkCammerStreamHealth && this.session.room.session.id) {
      this.initializeStreamHealth()
    }
  }

  getArrayLatencies () {
    const storageData = localStorage.getItem(this.STREAM_HEALTH_STORAGE_NAME)
    const arrayLatencies = storageData ? JSON.parse(storageData) : []
    return arrayLatencies
  }

  deleteArrayLatencies () {
    localStorage.removeItem(this.STREAM_HEALTH_STORAGE_NAME)
  }

  initializeStreamHealth () {
    const latencies = this.getArrayLatencies()
    if (latencies !== null) {
      this.deleteArrayLatencies()
    }

    this.intervalClear = setInterval(() => {
      this.startTime = Date.now()

      Vue.prototype.$socketEvents.healthPing()
      
      if (this.userConfigs && this.userConfigs?.widget_app_generate_data) {
        const storage:any = store.state.storage
        const widgetState = storage.state

        if (this.timeLimite === this.MAX_TIME && widgetState.id === 4) {
          this.timeLimite = 0

          this.sendLatencyAPI(true)
        }
        this.timeLimite += 1
      }
    }, this.TIME_PING)
  }

  getTimeLocale () {
    const d = new Date()
    return d.toLocaleTimeString()
  }

  saveLatencies() {
    let latency = Date.now() - this.startTime

    if (this.userConfigs?.show_icons?.widget || this.userConfigs?.show_charts?.widget) {
      Vue.prototype.$socketEvents.sendSignalLatency(latency)
    }

    if (this.userConfigs && this.userConfigs?.widget_app_generate_data) {
      let latencies:any = this.getArrayLatencies()
      latencies.push({
        value: latency,
        date: this.getTimeLocale()
      })

      localStorage.setItem(this.STREAM_HEALTH_STORAGE_NAME, JSON.stringify(latencies))
    }
  }

  async sendLatencyAPI(callIsActive:boolean) {
    const latencies = this.getArrayLatencies()
    const widget:any = store.state.widget
    const category = this.session ? this.session.category : null
    const organization = widget.data ? widget.data.organization : null

    if (latencies.length) {
      const dateApiLatency = {
        session_id: this.session.room.session.id,
        app: 'widget',
        latency_data: latencies,
        organization_id: organization ? organization.id : null,
        device:  MediaDevices.getDevice(),
        widget_uuid: widget.data ? widget.data.uuid : null,
        category_id: category ? category.id : null,
        call_is_active: callIsActive,
      }

      if (callIsActive) {
        this.deleteArrayLatencies()
      }

      Vue.prototype.$socketEvents.storageLatency(dateApiLatency)
    }
  }

  stopIntervalLatency () {
    if (this.intervalClear) {
      clearInterval(this.intervalClear)
    }

    if (this.session) {
      this.sendLatencyAPI(false)
    }
  }
}

export default new StreamHealth()
